export default "__VITE_ASSET__q_TFhIsU__"